const burger = document.querySelector('.burger');
const menu = document.getElementById('main-menu');

if (burger && menu) {
    menu.hidden = true;

    burger.addEventListener('click', () => {
        const expanded = burger.getAttribute('aria-expanded') === 'true';

        burger.setAttribute('aria-expanded', String(!expanded));
        menu.hidden = expanded;
    });
}

document
    .querySelectorAll('.main-items__title[aria-haspopup="true"]')
    .forEach(link => {
        const submenuId = link.getAttribute('aria-controls');
        const submenu = document.getElementById(submenuId);

        if (!submenu) return;

        submenu.hidden = true;

        link.addEventListener('click', e => {
            e.preventDefault();

            const expanded = link.getAttribute('aria-expanded') === 'true';

            link.setAttribute('aria-expanded', String(!expanded));
            submenu.hidden = expanded;
        });

        submenu.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                link.setAttribute('aria-expanded', 'false');
                submenu.hidden = true;
                link.focus();
            }
        });

        submenu.addEventListener('focusout', e => {
            if (!submenu.contains(e.relatedTarget)) {
                link.setAttribute('aria-expanded', 'false');
                submenu.hidden = true;
            }
        });
    });